import Header from '@/types/app/header';

export default class AccountDocumentHeader {
  public static header: Header[] = [
    {
      text: 'Investor',
      align: 'start',
      sortable: true,
      value: 'investorName',
      class: 'item-table-header item-table-header-name',
      width: ""
    },   
    {
      text: 'Email',
      align: 'start',
      sortable: true,
      value: 'email',
      class: 'item-table-header item-table-header-refused',
      width: ""
    },
    {
      text: 'Account Number',
      align: 'start',
      sortable: true,
      value: 'accountNumber',
      class: 'item-table-header item-table-header-refused',
      width: ""
    },
    {
      text: '',
      align: 'right',
      value: 'actions',
      sortable: false,
      class: null,
      width: ""
    }
  ];
}
